import React, { Component } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFolderOpen } from "@fortawesome/free-regular-svg-icons";

export default class OpenIconWrap extends Component {
  render() {
    const {
      updateShowGetProductionJsonModal
    } = this.props;
    return (
      <div className="col-1">
        <button type="button" className="btn" onClick={
          (e) => {
            updateShowGetProductionJsonModal(true)
          }}>
          <FontAwesomeIcon icon={ faFolderOpen } />
        </button>
      </div>
    )
  }
}
